import { ApplicationConfigDefinition } from '../../shared/model/local/config/application-config-definition';
import { environment } from '../../../environment/environment';
import { en } from '@faker-js/faker';

export const ApplicationConfig: ApplicationConfigDefinition = {
  type: environment.type,
  applicationOwner: 'Apzumi',
  applicationName: 'Visera',
  version: '5.0',
  device: 'eyJwbGF0Zm9ybSI6ICJXZWIifQ==',
  apiUrl: environment.apiUrl,
  production: environment.production,
  defaultLanguage: environment.defaultLanguage,
  auth: {
    domain: environment.auth0!.domain,
    clientId: environment.auth0!.clientId,
    audience: environment.auth0!.audience,
  },
  // cognito: environment?.cognito,
};
